// extracted by mini-css-extract-plugin
export var body = "_f5-0";
export var sectionHeader = "_f5-4";
export var shortcutColumns = "_f5-2";
export var shortcutList = "_f5-1";
export var shortcutSection = "_f5-3";